// extracted by mini-css-extract-plugin
export default {"drawer":"CX","drawerheader":"EX","retake_quiz_bottom_bar":"FX","extra_drawer":"GX","not_answered_questions":"HX","question_ui":"IX","accordion_details":"JX","retake_quiz":"KX","accordions":"LX","accordion_root":"MX","accordion_summary_text":"NX","animation":"OX","show_animation":"PX","overflow_hidden":"QX"};
    if(module.hot) {
      // 1743628928546
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  